import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'
import tim from '@/framework/utils/chat/tim'
import TIM from "tim-js-sdk"
import genTestUserSig from '@/framework/utils/chat/GenerateTestUserSig'
Vue.use(Vuex)
const getMyHost=()=>{
  //保存当前域名
  let myHost=location.protocol+'//' + location.host
  if (myHost.indexOf("localhost")>0){
    myHost="https://iis.libtop.com"
  }
  return myHost
}
const initPageState = () => {
  return {
    user: {
      realname: '' || JSON.parse(localStorage.getItem('h5_web_userCache')) ? JSON.parse(localStorage.getItem('h5_web_userCache')).realname : '',
      avatar: '' || JSON.parse(localStorage.getItem('h5_web_userCache')) ? JSON.parse(localStorage.getItem('h5_web_userCache')).avatar : '',
      id: '' || JSON.parse(localStorage.getItem('h5_web_userCache')) ? JSON.parse(localStorage.getItem('h5_web_userCache')).id : '',
      phone: '' || JSON.parse(localStorage.getItem('h5_web_userCache')) ? JSON.parse(localStorage.getItem('h5_web_userCache')).phone : '',
      identity: '' || JSON.parse(localStorage.getItem('h5_web_userCache')) ? JSON.parse(localStorage.getItem('h5_web_userCache')).identity : '',
      email: '' || JSON.parse(localStorage.getItem('h5_web_userCache')) ? JSON.parse(localStorage.getItem('h5_web_userCache')).email : '',
    },
    IMLogin: false,
    userList: [],  //聊天用户列表
    messageList: [],  //聊天信息
    prefix: getMyHost() + '/attachment/',
    targetUrl: getMyHost(),
    // prefix: 'http://ptest38.paoding.xyz/attachment/',
    // prefix: 'http://itest38.paoding.xyz/attachment/',
    language: localStorage.language || 'zh',
    currentChatId: localStorage.currentChatId || ''
  }
}
const store = new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  state: initPageState(),
  mutations: {
    [types.SAVE_USER](state, pageState) {
      for (const prop in pageState) {
        state.user[prop] = pageState[prop]
      }
    },
    clear(state, val) {
      state.user = {
        realname: '',
        avatar: '',
        id: '',
        phone: '',
        identity: '',
        email: ''
      }
      state.userList = []
      state.messageList = []
    },
    SAVE_REALNAME(state, val) {
      state.user.realname = val
    },
    SAVE_AVATAR(state, val) {
      state.user.avatar = val
    },
    SAVE_EMAIL(state, val) {
      state.user.email = val
    },
    SAVE_PHONE(state, val) {
      state.user.phone = val
    },
    SAVE_LANG(state, lang) {
      state.language = lang
    },
    SAVE_CURRENT_CHAT_ID(state, id) {
      state.currentChatId = id
    },
    //登录IM
    LOGIN_IM(state, val) {
      //登录IM
      let id = state.user.id.toString()
      tim.login({userID: id, userSig: genTestUserSig(id).userSig})
        .then((imResponse) => {
          this.$store.state.IMLogin = true
        }).catch(function (imError) {
      })
    },
    //更新聊天用户列表
    updateUserList(state,payload){
      tim.getConversationList().then(res => {
        state.userList=JSON.parse(JSON.stringify(res.data.conversationList))
      }).catch(() => {
        // console.log('获取会话列表失败')
      })
    },
    //更新聊天信息
    updateMsgList(state, msgList) {// 判断当前有没有聊天的对象 避免未选择对象时 直接追加消息的bug
      if (!localStorage.currentChatId){
        return false
      }
      //收到别人发送的
      if(msgList.sendByOtherUser){
        if(msgList.from===localStorage.currentChatId){
          state.messageList.push(JSON.parse(JSON.stringify(msgList)))
        }
      }
      //自己发送给别人的
      else{
        if(msgList.to===localStorage.currentChatId){
          state.messageList.push(JSON.parse(JSON.stringify(msgList)))
        }
      }
    },
    // 获取当前聊天对象的聊天内容
    getMessageList(state,conversationID) {
      tim.getMessageList({conversationID, count: 15}).then(imReponse => {
        // 更新当前消息列表，从头部插入
        state.messageList = JSON.parse(JSON.stringify(imReponse.data.messageList))
        return state.messageList
      })
    },
    //清除聊天内容
    clearMessageList(state){
      state.messageList=[]
    },
    CHANGE_SLOT(state, id) {
      const key = id + ''
      if (state.msgList[key] && state.msgList[key].length > 0) {
        state.msgList[key].forEach(item => {
          item.unread = false
        })
      }
    },
  },
  actions: {
    [types.SAVE_USER_CACHE]() {
      let user = this.state.user
      if (user.id !== '') {
        if (window.localStorage) {
          let ls = window.localStorage
          let userCache = ls.getItem('h5_web_userCache')
          if (userCache) {
            ls.removeItem('h5_web_userCache')
          }
          ls.setItem('h5_web_userCache', JSON.stringify(user))
        }
      }
    },
    [types.CLEAR_USER_CACHE]() {
      if (window.localStorage) {
        let ls = window.localStorage
        ls.removeItem('h5_web_userCache')
      }
    },
    [types.GET_USER_CACHE]() {
      if (window.localStorage) {
        let ls = window.localStorage
        let userStr = ls.getItem('h5_web_userCache')
        let user = JSON.parse(userStr)
        this.commit(types.SAVE_USER, {
          user: user
        })
      }
    },
    [types.GET_USER_EXIST]() {
      if (window.localStorage) {
        let ls = window.localStorage
        let userStr = ls.getItem('h5_web_userCache')
        return !!userStr
      }
    },
    SAVE_MSGLIST_CACHE(context, payload) {
      let signId = payload.bySelf ? payload.to : payload.from
      let msgList = JSON.parse(localStorage.msgList)
      if (!msgList[signId]) {
        msgList[signId] = []
        msgList[signId].push(payload)
        localStorage.setItem("msgList", JSON.stringify(msgList))
      } else {
        msgList[signId].push(payload)
        localStorage.setItem("msgList", JSON.stringify(msgList))
      }
    },
    // 切换小红点的显示与隐藏（即修改）
    CHANGE_SLOT(context, payload) {
      // 同步vuex
      context.commit('CHANGE_SLOT', payload)
      // 修改缓存
      const key = payload + ''
      let msgList = JSON.parse(localStorage.msgList)
      if (msgList[key] && msgList[key].length > 0) {
        msgList[key].forEach(item => {
          if (item.unread) item.unread = false
        })
        localStorage.setItem('msgList', JSON.stringify(msgList))
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/framework/store/index.js